var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout"},[_c('Breadcrumbs',{attrs:{"main":"","title":"结帐"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('h1',[_vm._v("待定")]),_c('div',{staticClass:"card"})])
}]

export { render, staticRenderFns }